import React, { useContext, useEffect, useState } from 'react';
import { Box, Divider, MenuItem, Select, SelectChangeEvent, Skeleton, Tab, Typography } from '@mui/material';
import { DashboardCard, DashboardCardNR1, DashboardContainer, Grafico, Graficos, HomeContainer, LegendContainer, SkeletonChartContainer, SkeletonContainer, UserArea } from './Home.styles';
import { useTenantService } from '../../hooks/services/useTenantService';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import UserContext from '../../context/user/UserContext';
import { DatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import WizardTextField from '../wizard/components/WizardTextField';
import moment from 'moment';
import { AverageDaysValueChart } from './charts/AvegageDaysValueChart';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import InsertChartOutlinedSharpIcon from '@mui/icons-material/InsertChartOutlinedSharp';
import PsychologySharpIcon from '@mui/icons-material/PsychologySharp';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
} from 'chart.js';
import { Pie, Doughnut } from 'react-chartjs-2';
import { DocAndHoursChart } from './charts/DocAndHoursChart';
import { ResponsiveContainer } from 'recharts';
import TabContext from '@mui/lab/TabContext/TabContext';
import { TabList, TabPanel } from '@mui/lab';
import { useMedicalCertificateService } from '../../hooks/services/useMedicalCertificateService';
import ThemeOptionContext from '../../context/theme-option/ThemeOptionContext';
import { DayAndMonthMedicalCertificate } from './charts/DayAndMonthMedicalCertificate';
import { SkeletonChartLoader } from '../skeleton/Skeleton';
import { SkeletonChartNR1 } from '../skeleton/SkeletonCardNr1';
import { RankEmployesWithMoreMedicalCertificate } from './charts/RankEmployesWithMoreMedicalCertificate';
import { RankWorkstationWithMoreMedicalCertificate } from './charts/RankWorkstationMedicalCertificate';
import { hasAccessTo } from '../../util/hasAccessTo';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import WbTwilightOutlinedIcon from '@mui/icons-material/WbTwilightOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';

ChartJS.register(CategoryScale, LinearScale, ArcElement, BarElement, Title, Tooltip, Legend, PointElement, LineElement);

interface IMonth {
  value: number;
  text: string;
}

interface IHomeProps {
  title: string;
}

interface IRiskByWorkstation {
  workstation: string;
  count: number;
  percentage: string;
}
interface IRiskBySector {
  locals: string;
  count: number;
  percentage: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = -12;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 190,
    },
  },
};

const Home: React.FC<IHomeProps> = ({ title, ...rest }) => {
  window.document.title = title;

  const { state: userState } = useContext(UserContext);
  const { state: themeState } = useContext(ThemeOptionContext);

  const [months] = useState<IMonth[]>(() => {
    return [
      { value: 0, text: 'Ano todo' },
      { value: 0.1, text: 'Período Personalizado' },
      { value: 1, text: 'Janeiro' },
      { value: 2, text: 'Fevereiro' },
      { value: 3, text: 'Março' },
      { value: 4, text: 'Abril' },
      { value: 5, text: 'Maio' },
      { value: 6, text: 'Junho' },
      { value: 7, text: 'Julho' },
      { value: 8, text: 'Agosto' },
      { value: 9, text: 'Setembro' },
      { value: 10, text: 'Outubro' },
      { value: 11, text: 'Novembro' },
      { value: 12, text: 'Dezembro' },
    ];
  });
  const [years] = useState<Number[]>(() => {
    const arrayYears = [];
    for (let i = 2022; i <= 2050; i++) {
      arrayYears.push(i);
    }
    return arrayYears;
  });

  const [monthSelected, setMonthSelected] = useState(() => {
    const currentMonth = new Date().getMonth() + 1;
    return currentMonth.toString();
  });
  const [yearSelected, setYearSelected] = useState(() => {
    const currentYear = new Date().getUTCFullYear();
    return currentYear.toString();
  });
  const [medicalCertificate, setMedicalCertificate] = useState(0);
  const [employee, setEmployee] = useState(0);
  const [employeeWithAttestation, setEmployeeWithAttestation] = useState(0);
  const [timeAwayName, setTimeAwayName] = useState(['']);
  const [timeAwayValue, setTimeAwayValue] = useState([0]);
  const [docAndHoursName, SetDocAndHoursName] = useState(['']);
  const [docAndHoursQtdDoc, setDocAndHoursQtdDoc] = useState([0]);
  const [docAndHoursTotalHours, setDocAndHoursTotalHours] = useState([0]);
  const [documentByCIDName, setDocumentByCIDName] = useState(['']);
  const [documentByCIDValue, setDocumentByCIDValue] = useState([0]);
  const [averageDaysValue, setAverageDaysValue] = useState<number>(0);
  const [cid, setCid] = useState('');
  const [rankOfEmployesWithMoreMedicalCertificate, setRankOfEmployesWithMoreMedicalCertificate] = useState<
    { name: string; code: string; qtddoc: string }[]
  >();
  const [ageEmployeeMedicalCertificate, setAgeEmployeeMedicalCertificate] = useState<{
    age: string[];
    count: string[];
  }>();
  const [genderEmployeeMedicalCertificate, setGenderEmployeeMedicalCertificate] = useState<{
    gender: string[];
    count: string[];
  }>();
  const [workstationEmployeeMedicalCertificate, setWorkstationEmployeeMedicalCertificate] = useState<{
    workstation: string[];
    count: string[];
    countListMedicalInWorkstation: string[];
    totalEmployeesFoundInWorkstation: string[];
  }>();
  const [employeeMedicalCertificateByStatus, setEmployeeMedicalCertificateByStatus] = useState<{
    status: string[];
    count: string[];
  }>();
  const [employeeByDocuments, setEmployeeByDocuments] = useState<{
    type: string[];
    count: string[];
  }>();
  const [loading, setLoading] = useState(false);
  const [loadingNR1, setLoadingNR1] = useState(false);
  const [customPeriod, setCustomPeriod] = useState(true);
  const [initialDate, setInitialDate] = useState<string>(String(moment(new Date()).startOf('month')));
  const [endDate, setEndDate] = useState<string>(String(moment(new Date()).endOf('month')));

  const [monitoredNrCid, setMonitoredNrCid] = useState('');
  const [incidenceNrCid, setIncidenceNrCid] = useState('');
  const [riskNrByPosition, setRiskNrByPosition] = useState<IRiskByWorkstation[]>([]);
  const [riskNrBySector, setRiskNrBySector] = useState<IRiskBySector[]>([]);
  const [riskNrByGenderFemale, setRiskNrByGenderFemale] = useState('');
  const [riskNrByGenderMale, setRiskNrByGenderMale] = useState('');
  const [totalNr1, setTotalNr1] = useState('')
  const [cidWithHigherRisk, setCidWithHigherRisk] = useState<{ code: string; count: number; description: string }[]>([]);
  const [medicalCertificateByDayAndMonth, setMedicalCertificateByDayAndMonth] = useState<{ date: string, count: number }[]>([]);

  const [valueTab, setValueTab] = React.useState('1');
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValueTab(newValue);
  };

  const toastr = useToastrVanila();

  const { getTenantInfo } = useTenantService();

  const {
    getIsMonitoredNR1,
    getIncidenceEmployeeRiskNR1,
    getRiskNr1ByPosition,
    getRiskNr1BySector,
    getRiskNr1Gender,
    getTotalMedicalCertificatesWithNR1,
    getCidWithHigherRisk,
    getMedicalCertificateByDayAndMonth
  } = useMedicalCertificateService();

  const formatDateToISO = (date: Date | string): string => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  async function handleCustomDate(dataChange: string | Date | null, type: 'initial' | 'end') {
    if (!dataChange) return;
    const formattedDate = formatDateToISO(dataChange);

    if (type === 'initial') {
      setInitialDate(formattedDate ?? null);
      if (endDate) {
        const formattedEndDate = formatDateToISO(endDate)
        if (formattedDate > formattedEndDate) {
          toastr.error("A data inicial não pode ser maior que a final.");
          setInitialDate(initialDate);
          return;
        }
        await handleLoadinData(formattedDate, formattedEndDate);
        await handleListAllNR1(formattedDate, formattedEndDate);
      }
    } else {
      setEndDate(formattedDate ?? null);
      const formattedInitialDate = formatDateToISO(initialDate)
      if (formattedInitialDate && formattedDate && formattedInitialDate > formattedDate) {
        toastr.error("A data final não pode ser menor que a inicial");
        setEndDate(endDate)
        return;
      }
      await handleLoadinData(formattedInitialDate, formattedDate);
      await handleListAllNR1(formattedInitialDate, formattedDate);
    }

  }

  const handleChangeMonth = async (event: SelectChangeEvent) => {
    if (Number(event.target.value) === 0.1) {
      event.preventDefault();
      setCustomPeriod(false);
      setMonthSelected(String(event.target.value));

      const formattedStart = formatDateToISO(initialDate);
      const formattedEnd = formatDateToISO(endDate);

      await handleLoadinData(formattedStart, formattedEnd);
      await handleListAllNR1(formattedStart, formattedEnd);
    } else {
      setCustomPeriod(true);
      setMonthSelected(String(event.target.value));

      let competenceDateFinal = null;
      let competenceDate = `${yearSelected}-${String(event.target.value)?.length === 1 ? `0${String(event.target.value)}` : String(event.target.value)
        }-01`;

      if (String(event.target.value) === '0') {
        competenceDate = `${yearSelected}-01-01`;
        competenceDateFinal = `${yearSelected}-12-31`;
      }

      await handleLoadinData(competenceDate, competenceDateFinal);
      await handleListAllNR1(competenceDate, competenceDateFinal);
    }
  };

  const handleChangeYear = async (event: SelectChangeEvent) => {
    setYearSelected(String(event.target.value));

    let competenceDateFinal = null;
    let competenceDate = `${event.target.value}-${monthSelected?.length === 1 ? `0${monthSelected}` : monthSelected
      }-01`;

    if (monthSelected === '0') {
      competenceDate = `${event.target.value}-01-01`;
      competenceDateFinal = `${event.target.value}-12-31`;
    }

    await handleLoadinData(competenceDate, competenceDateFinal);
    await handleListAllNR1(competenceDate, competenceDateFinal);
  };

  const handleLoadinData = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoading(true);

    await getTenantInfo(competenceDate, competenceDateFinal)
      .then(response => {
        setMedicalCertificate(response?.medicalCertificate);
        setEmployee(response?.employee);
        setEmployeeWithAttestation(response?.employeeWithAttestation);
        setTimeAwayName(response?.timeAwayName);
        setTimeAwayValue(response?.timeAwayValue);
        setDocumentByCIDName(response?.documentByCIDName);
        setDocumentByCIDValue(response?.documentByCIDValue);
        SetDocAndHoursName(response?.docAndHoursName);
        setDocAndHoursQtdDoc(response?.docAndHoursQtdDoc);
        setDocAndHoursTotalHours(response?.docAndHoursTotalHours);
        setAverageDaysValue(response?.averageDaysValue ?? 0);
        setRankOfEmployesWithMoreMedicalCertificate(response?.rankOfEmployesWithMoreMedicalCertificate);
        setAgeEmployeeMedicalCertificate(response?.ageEmployeeMedicalCertificate);
        setGenderEmployeeMedicalCertificate(response?.genderEmployeeMedicalCertificate);
        setWorkstationEmployeeMedicalCertificate(response?.workstationEmployeeMedicalCertificate);
        setEmployeeMedicalCertificateByStatus(response?.employeeMedicalCertificateByStatus);
        setEmployeeByDocuments(response?.employeeByDocuments);
        if (response?.cid.code && response?.cid.code !== ' ') {
          setCid(`${response?.cid.code} - ${response?.cid.description}`);
        } else {
          setCid('');
        }
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleLoadingDataNR1 = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoadingNR1(true);

    await getIsMonitoredNR1(competenceDate, competenceDateFinal)
      .then(response => {
        setMonitoredNrCid(response?.isMonitoredNR1Porcentual)
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoadingNR1(false);
      })
  }

  const handleIncidenceEmployeeRiskNr1 = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoadingNR1(true);

    await getIncidenceEmployeeRiskNR1(competenceDate, competenceDateFinal)
      .then(response => {
        setIncidenceNrCid(response?.incidenceEmployeePercentage)
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoadingNR1(false);
      })
  }

  const handleRiskNr1ByPosition = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoadingNR1(true);
    await getRiskNr1ByPosition(competenceDate, competenceDateFinal)
      .then(response => {
        const data = response?.risksByWorkstation ?? [];

        if (data.length <= 9) {
          setRiskNrByPosition(data);
          return;
        }

        const sorted = [...data].sort(
          (a, b) => parseFloat(b.percentage) - parseFloat(a.percentage)
        );

        const top9 = sorted.slice(0, 9);
        const others = sorted.slice(9);

        const othersPercentage = others
          .reduce((sum, item) => sum + parseFloat(item.percentage), 0)
          .toFixed(2);

        setRiskNrByPosition([
          ...top9,
          { workstation: 'Outros', percentage: othersPercentage } as IRiskByWorkstation,
        ]);
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoadingNR1(false);
      });
  };

  const handleRiskNR1BySector = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoadingNR1(true);
    await getRiskNr1BySector(competenceDate, competenceDateFinal)
      .then(response => {

        const data = response?.risksBySector ?? [];

        if (data.length <= 9) {
          setRiskNrBySector(data);
          return;
        }

        const sorted = [...data].sort(
          (a, b) => parseFloat(b.percentage) - parseFloat(a.percentage)
        );

        const top9 = sorted.slice(0, 9);
        const others = sorted.slice(9);

        const othersPercentage = others
          .reduce((sum, item) => sum + parseFloat(item.percentage), 0)
          .toFixed(2);

        setRiskNrBySector([
          ...top9,
          { locals: 'Outros', percentage: othersPercentage } as IRiskBySector,
        ]);
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoadingNR1(false);
      })
  }

  const handleRiskNr1Gender = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoadingNR1(true);

    await getRiskNr1Gender(competenceDate, competenceDateFinal)
      .then(response => {
        setRiskNrByGenderFemale(response?.riskByGenderFemale)
        setRiskNrByGenderMale(response?.riskByGenderMale)
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoadingNR1(false);
      })
  }

  const handleTotalMedicalCertificatesWithNR1 = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoadingNR1(true);
    await getTotalMedicalCertificatesWithNR1(competenceDate, competenceDateFinal)
      .then(response => {
        setTotalNr1(response?.totalMedicalCertificatesWithNR1)
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoadingNR1(false);
      })
  }

  const handleCidWithHigherRisk = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoadingNR1(true);
    await getCidWithHigherRisk(competenceDate, competenceDateFinal)
      .then(response => {
        setCidWithHigherRisk(response.cidWithHigherRisk);
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoadingNR1(false);
      });
  };

  const handleMedicalCertificateByDayAndMonth = async (competenceDate: string, competenceDateFinal?: string | null) => {
    setLoadingNR1(true);
    await getMedicalCertificateByDayAndMonth(competenceDate, competenceDateFinal)
      .then(response => {
        setMedicalCertificateByDayAndMonth(response?.countByMonth || response?.countByDay);
      })
      .catch(error => {
        toastr.error(error.message);
      })
      .finally(() => {
        setLoadingNR1(false);
      });
  };

  const handleListAllNR1 = async (formattedInitialDate: string, formattedDate: string | null) => {
    setLoadingNR1(true);
    if (hasAccessTo(["atestado-digital-rh", "atestado-digital-admin"], userState.resourcesWithActions)) {
      await handleLoadingDataNR1(formattedInitialDate, formattedDate);
      await handleIncidenceEmployeeRiskNr1(formattedInitialDate, formattedDate);
      await handleRiskNr1ByPosition(formattedInitialDate, formattedDate);
      await handleRiskNR1BySector(formattedInitialDate, formattedDate);
      await handleRiskNr1Gender(formattedInitialDate, formattedDate);
      await handleTotalMedicalCertificatesWithNR1(formattedInitialDate, formattedDate);
      await handleCidWithHigherRisk(formattedInitialDate, formattedDate);
      await handleMedicalCertificateByDayAndMonth(formattedInitialDate, formattedDate);
    }
    setLoadingNR1(false);
  }

  const numberOfEmployees = [
    { name: 'Colaboradores', value: employee },
    { name: 'Colabodores com documento', value: employeeWithAttestation },
  ];

  let documentByCID: any[] | undefined = [];

  documentByCID = documentByCIDName?.map((_, index: any) => {
    return { name: documentByCIDName[index], value: documentByCIDValue[index] };
  });

  let docAndHours: any[] | undefined = [];

  docAndHours = docAndHoursName?.map((_, index: any) => {
    return {
      name: docAndHoursName[index],
      Documentos: docAndHoursQtdDoc[index],
      Horas: docAndHoursTotalHours[index],
    };
  });

  const colors = [
    '#4A81F5',
    '#936DF5',
    '#2DD681',
    '#FED469',
    '#FEA190',
    '#E91E63',
    '#26A69A',
    '#673AB7',
    '#FF7043',
    '#ABB7C5',
    '#45B3E8',
    '#5E00D7',
    '#D5FACF',
    '#FEBB74',
    '#FF8450',
    '#74E4A2',
    '#6C7C93',
    '#AF66BD',
    '#FF0000',
    '#097261',
  ];

  useEffect(() => {
    if (customPeriod) {
      const competenceDateFinal = null;
      const competenceDate = `${yearSelected}-${monthSelected?.length === 1 ? `0${monthSelected}` : monthSelected}-01`;

      handleLoadinData(competenceDate, competenceDateFinal);
      handleListAllNR1(competenceDate, competenceDateFinal);
    } else {
      handleLoadinData(initialDate, endDate);
      handleListAllNR1(initialDate, endDate);
    }
  }, []);

  const statusColors = { Pendendte: 'gray', Aprovado: 'green', Reprovado: 'red', Pendente: '#F57C00' };

  const datalabelsPlugin = {
    id: 'datalabels',
    afterDraw(chart: any) {
      const { ctx } = chart;
      chart.data.datasets?.forEach((dataset: any, datasetIndex: number) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.data.forEach((element: any, index: number) => {
          if (!chart.getDataVisibility(index)) return;
          const { x, y } = element.tooltipPosition();
          const value = dataset.data[index];
          if (value == null) return;
          ctx.save();
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.font = 'bold 14px sans-serif';
          ctx.fillStyle = themeState && themeState.isDark ? '#FFFFFF' : '#050505';
          ctx.fillText(`${value}%`, x, y);
          ctx.restore();
        });
      });
    },
  };
  const centerValueTextPlugin = (values: number[], isDark: boolean) => ({
    id: 'centerText',
    beforeDraw(chart: any) {
      const total = values.reduce((a, b) => a + b, 0);
      const { ctx, chartArea } = chart;
      const cx = (chartArea.left + chartArea.right) / 2;
      const cy = (chartArea.top + chartArea.bottom) / 2;
      ctx.save();
      ctx.font = 'bold 24px sans-serif';
      ctx.fillStyle = isDark ? '#FFFFFF' : '#050505';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(total, cx, cy);
      ctx.restore();
    },
  });

  const options = (isDark: boolean, containerID: string) => ({
    responsive: true,
    plugins: {
      htmlLegend: { containerID },
      legend: {
        display: false,
        position: 'right' as const,
        labels: {
          color: isDark ? '#FFFFFF' : '#050505',
          font: { size: 16 },
          generateLabels(chart: any) {
            const data = chart.data;
            return data.labels.map((label: string, i: number) => ({
              text: label.length > 20 ? label.slice(0, 20) + '…' : label,
              fullText: label,
              fontColor: isDark ? '#FFFFFF' : '#050505',
              fillStyle: data.datasets[0].backgroundColor[i] || colors[i % colors.length],
              strokeStyle: data.datasets[0].backgroundColor[i],
              lineWidth: 0,
              index: i,
            }));
          },
        },
        onHover(e: any, legendItem: any, legend: any) {
          const canvas = legend.chart.canvas;
          canvas.title = legendItem.fullText || '';
          canvas.style.cursor = 'pointer';
        },
        onLeave(e: any, legendItem: any, legend: any) {
          const canvas = legend.chart.canvas;
          canvas.title = '';
          canvas.style.cursor = 'default';
        },
      },
    },
  });

  function usePieChartData(rawCounts: (string | number)[] | undefined, isDark: boolean, containerID: string) {
    const labelColor = isDark ? '#FFFFFF' : '#050505';
    const counts = rawCounts?.map(Number) ?? [];
    const total = counts.reduce((acc, val) => acc + val, 0);
    const percentages = counts.map((val) =>
      total > 0 ? parseFloat(((val / total) * 100).toFixed(0)) : 0
    );
    const options = {
      plugins: {
        htmlLegend: { containerID },
        tooltip: {
          callbacks: {
            label: (context: any) => {
              const index = context.dataIndex;
              const count = counts[index];
              const percentage = percentages[index];
              return `${count} documento(s) (${percentage}%)`;
            },
          },
        },
        datalabels: {
          display(context: any) {
            return context.chart.getDataVisibility(context.dataIndex);
          },
        },
        legend: {
          display: false,
          position: 'right' as const,
          labels: {
            color: labelColor,
            font: { size: 16 },
            generateLabels(chart: any) {
              const data = chart.data;
              return data.labels.map((label: string, i: number) => ({
                text: label.length > 20 ? label.slice(0, 20) + '…' : label,
                fullText: label,
                fontColor: labelColor,
                fillStyle: data.datasets[0].backgroundColor[i] || colors[i % colors.length],
                strokeStyle: data.datasets[0].backgroundColor[i],
                lineWidth: 0,
                index: i,
              }));
            },
          },
          onHover(e: any, legendItem: any, legend: any) {
            const canvas = legend.chart.canvas;
            canvas.title = legendItem.fullText || '';
            canvas.style.cursor = 'pointer';
          },
          onLeave(e: any, legendItem: any, legend: any) {
            const canvas = legend.chart.canvas;
            canvas.title = '';
            canvas.style.cursor = 'default';
          },
        },
      },
    };
    return { counts, total, percentages, options };
  }

  const codeCid = usePieChartData(documentByCIDValue, themeState.isDark, 'legend-cid');
  const gender = usePieChartData(genderEmployeeMedicalCertificate?.count, themeState.isDark, 'legend-gender');
  const status = usePieChartData(employeeMedicalCertificateByStatus?.count, themeState.isDark, 'legend-status');
  const riskByGender = usePieChartData([riskNrByGenderMale, riskNrByGenderFemale], themeState.isDark, 'legend-risk-gender'); //psicossicial
  const highRisk = usePieChartData(cidWithHigherRisk?.map(item => item.count), themeState.isDark, 'legend-high-risk'); //psicossicial

  const htmlLegendScrollPlugin = {
    id: 'htmlLegend',
    afterUpdate(chart: any) {
      const containerID = chart.options.plugins.htmlLegend?.containerID;
      if (!containerID) return;
      const container = document.getElementById(containerID);
      if (!container) return;

      const items = chart.options.plugins.legend.labels.generateLabels(chart);
      container.innerHTML = '';

      items.forEach((item: any) => {
        const hidden = !chart.getDataVisibility(item.index);

        const row = document.createElement('div');
        row.style.cssText = 'display:flex;align-items:center;gap:8px;margin-bottom:6px;cursor:pointer';

        const box = document.createElement('span');
        box.style.cssText = `width:36px;height:16px;border-radius:2px;flex-shrink:0;background:${hidden ? '#ccc' : item.fillStyle || '#ccc'}`;

        const text = document.createElement('span');
        text.style.cssText = `font-size:14px;color:${item.fontColor};${hidden ? 'text-decoration:line-through;opacity:0.5' : ''}`;
        text.textContent = item.text;
        text.title = item.fullText || item.text;

        row.onclick = () => {
          chart.toggleDataVisibility(item.index);
          chart.update();
        };

        row.appendChild(box);
        row.appendChild(text);
        container.appendChild(row);
      });
    },
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) {
      return { text: 'Bom dia', Icon: WbSunnyOutlinedIcon, color: '#f5a623' };
    }
    if (hour < 18) {
      return { text: 'Boa tarde', Icon: WbTwilightOutlinedIcon, color: '#ef8354' };
    }
    return { text: 'Boa noite', Icon: DarkModeOutlinedIcon, color: '#5c6bc0' };
  };

  const { text, Icon, color } = getGreeting();

  return (
    <HomeContainer>
      {hasAccessTo(["atestado-digital-gestor", "atestado-digital-rh", "atestado-digital-admin"], userState.resourcesWithActions) ? (
        <>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '24px 16px' }}>

            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Icon sx={{ fontSize: { xs: 18, sm: 22 }, color }} />
                <Typography
                  component="h1"
                  sx={{ fontSize: { xs: 16, sm: 21 }, fontWeight: 500, letterSpacing: '-0.2px' }}
                >
                  {text}, {userState?.name?.split(' ')[0]}
                </Typography>
              </div>
              <Typography sx={{ fontSize: { xs: 11, sm: 13 }, color: 'text.secondary', mt: 0.25 }}>
                Resumo dos documentos
              </Typography>
            </div>

          </div>
          <DashboardContainer>
            {loading ? (
              <SkeletonContainer>
                <Skeleton variant="text" width="65%" height={20} />
                <Skeleton variant="text" width="30%" height={42} sx={{ mt: 1 }} />
              </SkeletonContainer>
            ) : (
              <DashboardCard>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
                  <FilterAltIcon sx={{ color: '#1f8f87', fontSize: { xs: 14, sm: 18 } }} />
                  <span style={{ fontWeight: '500', color: '#209088' }}>Competência</span>
                </div>
                {customPeriod ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Select
                      labelId="select-month-id"
                      id="select-month-id"
                      onChange={handleChangeMonth}
                      value={monthSelected}
                      sx={{ width: '100%', height: { xs: '28px', sm: '30px' }, fontSize: { xs: '12px', sm: '14px' }, '& .MuiOutlinedInput-notchedOutline': { border: '1.5px solid #8d8e8f' } }}
                      MenuProps={MenuProps}
                    >
                      {months?.map(month => (
                        <MenuItem key={month.value} value={month.value}>
                          {month.text}
                        </MenuItem>
                      ))}
                    </Select>
                    <Select
                      labelId="select-year-id"
                      id="select-year-id"
                      onChange={handleChangeYear}
                      value={yearSelected}
                      sx={{ width: '100%', height: { xs: '28px', sm: '30px' }, fontSize: { xs: '12px', sm: '14px' }, '& .MuiOutlinedInput-notchedOutline': { border: '1.5px solid #8d8e8f' } }}
                      MenuProps={MenuProps}
                    >
                      {years?.map(y => (
                        <MenuItem key={String(y)} value={String(y)}>{`${y}`}</MenuItem>
                      ))}
                    </Select>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Select
                      labelId="select-month-id"
                      id="select-month-id"
                      onChange={handleChangeMonth}
                      value={monthSelected}
                      sx={{ width: '100%', height: { xs: '28px', sm: '30px' }, fontSize: { xs: '12px', sm: '14px' }, '& .MuiOutlinedInput-notchedOutline': { border: '1.5px solid #8d8e8f' } }}
                      MenuProps={MenuProps}
                    >
                      {months?.map(month => (
                        <MenuItem key={month.value} value={month.value}>
                          {month.text}
                        </MenuItem>
                      ))}
                    </Select>
                    <LocalizationProvider
                      dateAdapter={AdapterMoment}
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DatePicker
                        value={initialDate}
                        label="Data Inicial"
                        onChange={e => handleCustomDate(e, 'initial')}
                        renderInput={params => (
                          <WizardTextField
                            {...params}
                            error={false}
                            size="small"
                            placeholder="Data inicial"
                            sx={{
                              width: '100%',
                              '& .MuiInputBase-root': { height: { xs: '28px', sm: '30px' } },
                              '& .MuiInputBase-input': { padding: '4px 8px', fontSize: { xs: '11px', sm: '14px' } },
                              '& .MuiInputLabel-root': { fontSize: { xs: '11px', sm: '14px' }, top: '-4px' },
                              '& .MuiInputLabel-shrink': { top: 0 },
                              '& .MuiOutlinedInput-notchedOutline': { border: '1.5px solid #8d8e8f' },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider
                      dateAdapter={AdapterMoment}
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DatePicker
                        value={endDate}
                        label="Data Final"
                        onChange={e => handleCustomDate(e, 'end')}
                        renderInput={params => (
                          <WizardTextField
                            {...params}
                            error={false}
                            size="small"
                            placeholder="Data final"
                            sx={{
                              width: '100%',
                              '& .MuiInputBase-root': { height: { xs: '28px', sm: '30px' } },
                              '& .MuiInputBase-input': { padding: '4px 8px', fontSize: { xs: '11px', sm: '14px' } },
                              '& .MuiInputLabel-root': { fontSize: { xs: '11px', sm: '14px' }, top: '-4px' },
                              '& .MuiInputLabel-shrink': { top: 0 },
                              '& .MuiOutlinedInput-notchedOutline': { border: '1.5px solid #8d8e8f' },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                )}
              </DashboardCard>
            )}

            {loading ? (
              <SkeletonContainer>
                <Skeleton variant="text" width="65%" height={20} />
                <Skeleton variant="text" width="30%" height={42} sx={{ mt: 1 }} />
              </SkeletonContainer>
            ) : (
              <DashboardCard>
                <div>
                  <span style={{ fontWeight: '500' }}>Quantidade de documentos</span>
                </div>
                <div>
                  <h1>{medicalCertificate}</h1>
                </div>
              </DashboardCard>
            )}

            {loading ? (
              <SkeletonContainer>
                <Skeleton variant="text" width="65%" height={20} />
                <Skeleton variant="text" width="30%" height={42} sx={{ mt: 1 }} />
              </SkeletonContainer>
            ) : (
              <DashboardCard>
                <div>
                  <span style={{ fontWeight: '500' }}>Funcionários com documentos</span>
                </div>
                <div>
                  <h1>{employeeWithAttestation}</h1>
                </div>
              </DashboardCard>
            )}

            {loading ? (
              <SkeletonContainer>
                <Skeleton variant="text" width="65%" height={20} />
                <Skeleton variant="text" width="30%" height={42} sx={{ mt: 1 }} />
              </SkeletonContainer>
            ) : (
              <DashboardCard>
                <div>
                  <span style={{ fontWeight: '500' }}>CID com maior incidência</span>
                </div>
                <div>
                  <p>{cid || '-'}</p>
                </div>
              </DashboardCard>
            )}
          </DashboardContainer>
          <ResponsiveContainer width="100%" height="100%">

            <TabContext value={valueTab}>
              {loading
                ?
                  <Skeleton
                    variant="text"
                    width="100%"
                    height={80}
                  />
                :
                  <Box sx={{ bgcolor: themeState.isDark !== true ? '#FFFFFF' : '#121212', mt: { xs: 2, sm: 3 } }}>
                    <TabList onChange={handleChangeTab} aria-label="Tabela de gráficos" sx={{ '& .MuiTabs-indicator': { display: 'none' }, '& .MuiTabs-flexContainer': { justifyContent: 'center', flexWrap: 'wrap', gap: { xs: '4px', sm: '8px' } } }}>
                      <Tab
                        icon={<InsertChartOutlinedSharpIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />}
                        iconPosition="start"
                        label="Geral"
                        value="1"
                        sx={{ minHeight: 'auto', padding: { xs: '8px 12px', sm: '12px 16px' }, fontSize: { xs: '12px', sm: '14px' }, '&.Mui-selected': { backgroundColor: '#1f8f87', color: '#FFFFFF', border: '2px solid #1f8f87', borderRadius: '30px' } }}
                      />
                      {hasAccessTo(["atestado-digital-admin", "atestado-digital-rh"], userState.resourcesWithActions)
                        ?
                          <Tab
                            icon={<PsychologySharpIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />}
                            iconPosition="start"
                            label="Risco Psicossocial - NR1"
                            value="2"
                            sx={{ minHeight: 'auto', padding: { xs: '8px 12px', sm: '12px 16px' }, fontSize: { xs: '12px', sm: '14px' }, '&.Mui-selected': { backgroundColor: '#1f8f87', color: '#FFFFFF', border: '2px solid #1f8f87', borderRadius: '30px' } }}
                          />
                        : 
                          null
                      }

                    </TabList>
                    <Divider sx={{ mt: 1 }} orientation="horizontal" />
                  </Box>
              }
              <TabPanel value="1">
                <Graficos>
                  {loading ? (
                    <SkeletonChartLoader variant="doughnut" />
                  ) : numberOfEmployees?.length !== 0 ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                          Número de funcionários
                        </p>
                        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                          Atestados, colaboradores, declarações e outros tipos de documentos
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                          <div style={{ width: 300, height: 300 }}>
                            <Doughnut
                              data={{
                                labels: employeeByDocuments?.type,
                                datasets: [
                                  {
                                    label: '',
                                    data: employeeByDocuments?.count,
                                    backgroundColor: colors,
                                    borderWidth: 1,
                                  },
                                ],
                              }}
                              options={options(themeState.isDark, 'legend-number-employees')}
                              plugins={[htmlLegendScrollPlugin]}
                            />
                          </div>
                          <LegendContainer id="legend-number-employees" />
                        </div>
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {loading ? (
                    <SkeletonChartLoader variant="pie" />
                  ) : timeAwayName?.length !== 0 ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                          Total de horas por tipo de documento
                        </p>
                        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                          Total de horas de afastamento por tipo de documento
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                          <div style={{ width: 300, height: 300 }}>
                            <Pie
                              data={{
                                labels: timeAwayName,
                                datasets: [
                                  {
                                    label: '',
                                    data: timeAwayValue,
                                    backgroundColor: colors,
                                    borderWidth: 1,
                                  },
                                ],
                              }}
                              options={options(themeState.isDark, 'legend-time-away')}
                              plugins={[htmlLegendScrollPlugin]}
                            />
                          </div>
                          <LegendContainer id="legend-time-away" />
                        </div>
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {loading ? (
                    <SkeletonChartLoader variant="pie" />
                  ) : documentByCID?.length !== 0 ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                          Quantidade de documentos por código CID
                        </p>
                        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                          Percentual de documentos por CID
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                          <div style={{ width: 300, height: 300 }}>
                            <Doughnut
                              data={{
                                labels: documentByCIDName,
                                datasets: [{
                                  label: '',
                                  data: codeCid.percentages,
                                  backgroundColor: colors,
                                  borderWidth: 1,
                                }],
                              }}
                              options={codeCid.options}
                              plugins={[datalabelsPlugin, centerValueTextPlugin(documentByCIDValue ?? [], themeState.isDark), htmlLegendScrollPlugin]}
                            />
                          </div>
                          <LegendContainer id="legend-cid" />
                        </div>
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {loading ? (
                    <SkeletonChartLoader variant="pie" />
                  ) : ageEmployeeMedicalCertificate?.age.length !== 0 ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                          Quantidade de documentos por idade
                        </p>
                        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                          Documentos por faixa etária dos colaboradores
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                          <div style={{ width: 300, height: 300 }}>
                            <Pie
                              data={{
                                labels: ageEmployeeMedicalCertificate?.age,
                                datasets: [
                                  {
                                    label: '',
                                    data: ageEmployeeMedicalCertificate?.count,
                                    backgroundColor: colors,
                                    borderWidth: 1,
                                  },
                                ],
                              }}
                              options={options(themeState.isDark, 'legend-age-medical-certificate')}
                              plugins={[htmlLegendScrollPlugin]}
                            />
                          </div>
                          <LegendContainer id="legend-age-medical-certificate" />
                        </div>
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {loading ? (
                    <SkeletonChartLoader variant="pie" />
                  ) : genderEmployeeMedicalCertificate?.gender.length !== 0 ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                          Quantidade de documentos por gênero
                        </p>
                        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                          Documentos por gênero dos colaboradores
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                          <div style={{ width: 300, height: 300 }}>
                            <Pie
                              data={{
                                labels: genderEmployeeMedicalCertificate?.gender,
                                datasets: [
                                  {
                                    label: '',
                                    data: gender.percentages,
                                    backgroundColor: colors,
                                    borderWidth: 1,
                                  },
                                ],
                              }}
                              options={gender.options}
                              plugins={[datalabelsPlugin, htmlLegendScrollPlugin]}
                            />
                          </div>
                          <LegendContainer id="legend-gender" />
                        </div>
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {loading ? (
                    <SkeletonChartLoader variant="pie" />
                  ) : workstationEmployeeMedicalCertificate?.workstation.length !== 0 ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <RankWorkstationWithMoreMedicalCertificate
                          data={workstationEmployeeMedicalCertificate?.workstation.map((ws, i) => ({
                            workstation: ws,
                            count: workstationEmployeeMedicalCertificate.count,
                            countListMedicalInWorkstation: workstationEmployeeMedicalCertificate.countListMedicalInWorkstation[i],
                            totalEmployeesFoundInWorkstation: workstationEmployeeMedicalCertificate.totalEmployeesFoundInWorkstation[i],
                          })) ?? []}
                        />
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {employeeMedicalCertificateByStatus?.count.length !== 0 ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                          Status dos documentos
                        </p>
                        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                          Documentos por status
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                          <div style={{ width: 300, height: 300 }}>
                            <Pie
                              data={{
                                labels: employeeMedicalCertificateByStatus?.status,
                                datasets: [
                                  {
                                    data: status.percentages,
                                    backgroundColor: employeeMedicalCertificateByStatus?.status.map(
                                      status => statusColors[status as keyof typeof statusColors] || 'gray',
                                    ),
                                    borderWidth: 1,
                                  },
                                ]
                              }}
                              options={status.options}
                              plugins={[datalabelsPlugin, htmlLegendScrollPlugin]}
                            />
                          </div>
                          <LegendContainer id="legend-status" />
                        </div>
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {averageDaysValue !== 0 ? <AverageDaysValueChart averageDaysValue={averageDaysValue} /> : <br />}

                  <div style={{ width: '1090px', height: '100%' }}>
                    {loading ? (
                      <SkeletonChartLoader variant="doughnut" />
                    ) : rankOfEmployesWithMoreMedicalCertificate?.length ? (
                      <Grafico>
                        <RankEmployesWithMoreMedicalCertificate data={rankOfEmployesWithMoreMedicalCertificate} />
                      </Grafico>
                    ) : null}
                  </div>

                  {docAndHoursName?.length !== 0 ? (
                    <Grafico>
                      <DocAndHoursChart docAndHours={docAndHours} />
                    </Grafico>
                  ) : (
                    <br />
                  )}
                </Graficos>
              </TabPanel>

              <TabPanel value="2">
                <div style={{ display: 'flex', gap: '20px', padding: '24px', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                  {loadingNR1 ? (
                    <SkeletonChartNR1 />
                  ) : (
                    <>
                      <DashboardCardNR1 themeState={themeState}>
                        <h1>{monitoredNrCid?.split(".", 1)}%</h1>
                        <h3>Atestados com Risco Psicossocial</h3>
                        <p>Casos identificados com fatores de risco no período de competência.</p>
                      </DashboardCardNR1>

                      <DashboardCardNR1 themeState={themeState}>
                        <h1>{incidenceNrCid?.split(".", 1)}%</h1>
                        <h3>Colaboradores com Risco Psicossocial</h3>
                        <p>Colaboradores identificados com fatores de risco no período de competência.</p>
                      </DashboardCardNR1>

                      <DashboardCardNR1 themeState={themeState} >
                        <h1>{totalNr1}</h1>
                        <h3>Total de Atestados com Risco Psicossocial</h3>
                        <p>Atestados identificados com fatores de risco no período de competência.</p>
                      </DashboardCardNR1>
                    </>
                  )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '20px', padding: '24px' }} >

                  {loadingNR1
                    ? (
                      <SkeletonChartLoader variant="doughnut" />
                    ) : riskNrByPosition.length !== 0 ? (
                      <Grafico>
                        <div style={{ width: '520px', height: '480px' }}>
                          <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                            Atestados com Risco Psicossocial por Posto
                          </p>
                          <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                            Porcentagem de risco no setor
                          </span>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                            <div style={{ width: 300, height: 300 }}>
                              <Doughnut
                                data={{
                                  labels: riskNrByPosition.map(item => item.workstation),
                                  datasets: [
                                    {
                                      label: '% de Risco no setor:',
                                      data: riskNrByPosition.map(item => parseFloat(item.percentage)),
                                      backgroundColor: colors,
                                      borderWidth: 1,
                                    },
                                  ],
                                }}
                                options={options(themeState.isDark, 'legend-riskNr-position')}
                                plugins={[datalabelsPlugin, htmlLegendScrollPlugin]}
                              />
                            </div>
                            <LegendContainer id="legend-riskNr-position" />
                          </div>
                        </div>
                      </Grafico>
                    ) : (
                      <br />
                    )}

                  {loadingNR1
                    ? (
                      <SkeletonChartLoader variant="doughnut" />
                    ) : riskNrBySector.length !== 0 ? (
                      <Grafico>
                        <div style={{ width: '520px', height: '480px' }}>
                          <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                            Atestados com Risco Psicossocial por Local
                          </p>
                          <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                            Porcentagem de risco no local
                          </span>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                            <div style={{ width: 300, height: 300 }}>
                              <Doughnut
                                data={{
                                  labels: riskNrBySector.map(item => item.locals),
                                  datasets: [
                                    {
                                      label: '% de Risco no local:',
                                      data: riskNrBySector.map(item => parseFloat(item.percentage)),
                                      backgroundColor: colors,
                                      borderWidth: 1,
                                    },
                                  ],
                                }}
                                options={options(themeState.isDark, 'legend-riskNr-sector')}
                                plugins={[datalabelsPlugin, htmlLegendScrollPlugin]}
                              />
                            </div>
                            <LegendContainer id="legend-riskNr-sector" />
                          </div>
                        </div>
                      </Grafico>
                    ) : (
                      <br />
                    )}

                  {loadingNR1 ? (
                    <SkeletonChartLoader variant="pie" />
                  ) : (parseInt(riskNrByGenderMale) > 0 || parseInt(riskNrByGenderFemale) > 0) ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                          Atestados com Risco Psicossocial por Gênero
                        </p>
                        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                          Porcentagem de risco por gênero
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                          <div style={{ width: 300, height: 300 }}>
                            <Pie
                              data={{
                                labels: ['Masculino', 'Feminino'],
                                datasets: [
                                  {
                                    label: 'Risco por Gênero',
                                    data: riskByGender.percentages,
                                    backgroundColor: ["#4A81F5", "#AF66BD"],
                                  },
                                ],
                              }}
                              options={riskByGender.options}
                              plugins={[datalabelsPlugin, htmlLegendScrollPlugin]}
                            />
                          </div>
                          <LegendContainer id="legend-risk-gender" />
                        </div>
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {loadingNR1 ? (
                    <SkeletonChartLoader variant="pie" />
                  ) : cidWithHigherRisk.length !== 0 ? (
                    <Grafico>
                      <div style={{ width: '520px', height: '480px' }}>
                        <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
                          CIDs com alto risco psicossocial
                        </p>
                        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
                          Porcentagem de CIDs com alto risco
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 36, justifyContent: 'center', height: '90%' }}>
                          <div style={{ width: 300, height: 300 }}>
                            <Pie
                              data={{
                                labels: (cidWithHigherRisk ?? []).map(item => `${item.code}`),
                                datasets: [
                                  {
                                    label: 'nº de documentos:',
                                    data: highRisk.percentages,
                                    backgroundColor: colors,
                                  },
                                ],
                              }}
                              options={highRisk.options}
                              plugins={[datalabelsPlugin, htmlLegendScrollPlugin]}
                            />
                          </div>
                          <LegendContainer id="legend-high-risk" />
                        </div>
                      </div>
                    </Grafico>
                  ) : (
                    <br />
                  )}

                  {loadingNR1 ? (
                    <SkeletonChartContainer />
                  ) : medicalCertificateByDayAndMonth?.length !== 0 ? (
                    <div style={{ paddingTop: '32px' }}>
                      <DayAndMonthMedicalCertificate data={medicalCertificateByDayAndMonth} />
                    </div>
                  ) : (
                    <br />
                  )}

                </div>
              </TabPanel>
            </TabContext>
          </ResponsiveContainer>
        </>
      ) : (
        <UserArea>
          Olá <b>{userState.name}</b>, bem vindo ao sistema!{' '}
        </UserArea>
      )}
    </HomeContainer>
  );
};

export default Home;
